var _path, _circle, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlacklistSpamFaxes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0z",
    fill: "#E4FBF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 5,
    stroke: "#3ECF8E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h-7.91a.09.09 0 01-.09-.09v0A8.91 8.91 0 0122.91 26H24",
    stroke: "#3ECF8E",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 35l5-5m0 5l-5-5",
    stroke: "#3ECF8E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDBDMTAuNzQ1MyAwIDAgMTAuNzQ1MyAwIDI0QzAgMzcuMjU0NyAxMC43NDUzIDQ4IDI0IDQ4QzM3LjI1NDcgNDggNDggMzcuMjU0NyA0OCAyNEM0OCAxMC43NDUzIDM3LjI1NDcgMCAyNCAwWiIgZmlsbD0iI0U0RkJGMCIvPgo8Y2lyY2xlIGN4PSIyNCIgY3k9IjE4IiByPSI1IiBzdHJva2U9IiMzRUNGOEUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjIgMzVIMTQuMDg5MUMxNC4wMzk5IDM1IDE0IDM0Ljk2MDEgMTQgMzQuOTEwOVYzNC45MTA5QzE0IDI5Ljk4OTUgMTcuOTg5NSAyNiAyMi45MTA5IDI2SDI0IiBzdHJva2U9IiMzRUNGOEUiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNMjggMzVMMzMgMzBNMzMgMzVMMjggMzAiIHN0cm9rZT0iIzNFQ0Y4RSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgBlacklistSpamFaxes as ReactComponent };